module.exports = "../content/c3e05267434fd3639835de606e28e85a.woff2";